import axios from 'axios'
import { API } from 'constants/apiEndPoints'
import { useUser } from 'hooks/user/useUser'
import html2canvas from 'html2canvas'
import { useRef, useState } from 'react'
import { OrderSharingCardCSS } from './OrderSharingCardCSS.styled'
import twitterShare from 'twitter-share'
import { LVG_ASSETS } from 'constants/games/lvg/lvgAssets'
import { currencyFormatter } from 'utils'
import { config } from 'config/index'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { useActivePnl } from 'hooks/games/lvg/useActivePnL'
import { useTimeoutWhen } from 'utils/hooks/useTimeoutWhen'
import ms from 'ms.macro'
import { doCopy } from 'utils'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { copyBlobToClipboard } from 'copy-image-clipboard'
import { useChatMessagesManager } from 'hooks/chat/useChatMessagesManager'
import { logos } from 'common'
import { LONG_DASH } from 'constants'

const { YOLO_BASE_URL } = config

export const OrderSharingCard = ({ order, closeModal }) => {
  const { sendUserMessage } = useChatMessagesManager()
  const cardRef = useRef()
  const [loading, setLoading] = useState()
  const [disableMenu, setDisableMenu] = useState(false)
  const [executedAction, setExecutedAction] = useState()

  const { accessToken } = useUser('wallet')
  const { activePnl } = useActivePnl(order)
  const {
    pnl,
    userFillDollarAmount,
    asset: orderAsset,
    leverage,
    exitPrice: orderExitPrice,
    entryPrice: orderEntryPrice,
    side,
  } = order

  // ROI
  const roiNumber = Number(((pnl || activePnl) * 100) / userFillDollarAmount)
  const roi = isNaN(roiNumber)
    ? LONG_DASH
    : `${roiNumber.toFixed(Math.abs(roiNumber) < 1 && Math.abs(roiNumber) !== 0 ? 2 : 0)}%`
  const isWinning = roiNumber >= 0 ? true : false

  //Assets
  const assetData = LVG_ASSETS.find((asset) => asset.id === orderAsset)

  //Prices
  const entryPrice = currencyFormatter(orderEntryPrice, {
    decimalDigits: assetData.fiatDecimals,
  })
  const exitPrice = orderExitPrice
    ? currencyFormatter(orderExitPrice, {
        decimalDigits: assetData.fiatDecimals,
      })
    : LONG_DASH

  const getShareUrls = async (canvas) => {
    // document.body.appendChild(canvas)
    const image = canvas.toDataURL('image/png', 1.0)
    const blob = await fetch(image).then((res) => res.blob())
    const formData = new FormData()
    formData.append('file', blob, 'test.png')
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'content-type': 'multipart/form-data',
    }
    return axios.post(API.LVG_SHARE_TWITTER, formData, { headers }).then((response) => {
      return response?.data?.body
    })
  }

  const downloadImage = (canvas) => {
    const image = canvas.toDataURL('image/png', 1.0)
    const a = document.createElement('a')
    a.href = image
    a.download = `futures ${orderAsset} ${roi}.png`
    a.click()
    a.remove()
    setExecutedAction('default')
  }

  const shareTwitter = (htmlUrl) => {
    const params = {
      url: htmlUrl,
    }
    const tweetLink = twitterShare(params)
    const a = document.createElement('a')
    a.href = "javascript:window.open('" + tweetLink + "','_blank','height=400,width=600');"
    a.click()
    a.remove()
    setExecutedAction('default')
  }
  const shareChat = (imgUrl) => {
    // DISABLED: Silently prevent backend call but show normal UI feedback
    setExecutedAction('default')
    return;
    /*
    // const gifUrl = `/gif:: ${imgUrl}`
    const bodyMessage = {
      text: '',
      media: [
        {
          type: 'image',
          url: imgUrl,
        },
      ],
    }
    sendUserMessage(bodyMessage)
    setExecutedAction('default')
    */
  }

  const copyToClipboard = async (htmlUrl) => {
    const copied = await doCopy(htmlUrl)
    if (copied) setExecutedAction('copy')
    else setExecutedAction('default')
  }

  const copyImageToClipboard = async (canvas) => {
    const image = canvas.toDataURL('image/png', 1.0)
    const blob = await fetch(image).then((res) => res.blob())
    const copied = copyBlobToClipboard(blob)
    if (copied) setExecutedAction('image')
    else setExecutedAction('default')
  }

  const captureCard = (action) => {
    setDisableMenu(true)
    setLoading(true)
    const backgroundColor = getComputedStyle(cardRef.current).getPropertyValue('--share-card-background')
    html2canvas(cardRef.current, {
      // backgroundColor: '#12203c',
      backgroundColor,
      windowWidth: 1200,
      windowHeight: 675,
    }).then(async (canvas) => {
      switch (action) {
        case 'image':
          copyImageToClipboard(canvas)
          break
        case 'download':
          downloadImage(canvas)
          break
        case 'copy':
          const { htmlUrl: copyUrl } = await getShareUrls(canvas)
          copyToClipboard(copyUrl)
          break
        case 'twitter':
          const { htmlUrl: twitterUrl } = await getShareUrls(canvas)
          shareTwitter(twitterUrl)
          break
        case 'chat':
          const { imageUrl } = await getShareUrls(canvas)
          shareChat(imageUrl)
          break
        default:
          break
      }
    })
  }

  useTimeoutWhen(
    () => {
      setLoading(false)
      setExecutedAction('')
      setDisableMenu(false)
    },
    ms`5s`,
    executedAction,
    false
  )
  return (
    <OrderSharingCardCSS
      assetIcon={assetData.iconPng}
      assetIcon2={assetData.icon2Png}
      onClick={(e) => e.preventDefault()}
    >
      <div id='share-card' className='popup'>
        <div className='popUpContainer share-card wide-1200'>
          <article className='full twitter_share'>
            <div onClick={closeModal} className='closePopUp' />

            <div className='card_action_area'>
              <ContentSwitcherByState
                noWrapper
                activeState={executedAction}
                stateObject={{
                  default: (
                    <button disabled={loading} className='share_card_button'>
                      {loading && `Please wait `}
                      <SingleDataLoader loading={loading} data={' SHARE & DOWNLOAD IMAGE'} />
                    </button>
                  ),
                  copy: <div className='twitter_link_copied'>Link copied!</div>,
                  image: <div className='twitter_link_copied'>Image copied!</div>,
                  download: <></>,
                  twitter: <></>,
                }}
              />
              <nav className={`menu ${disableMenu ? 'hideActionMenu' : ''}`}>
                <ul>
                  <li>
                    <button className='copy_image_button share_menu_button' onClick={() => captureCard('image')}>
                      Copy image to clipboard
                    </button>
                  </li>
                  <li>
                    <button className='download_image_button share_menu_button' onClick={() => captureCard('download')}>
                      Download image
                    </button>
                  </li>
                  <li>
                    <button className='copy_link_button share_menu_button' onClick={() => captureCard('copy')}>
                      Copy link to clipboard
                    </button>
                  </li>
                  <li>
                    <button className='post_to_twitter share_menu_button' onClick={() => captureCard('twitter')}>
                      Post image to Twitter
                    </button>
                  </li>
                  <li>
                    <button className='share_in_chat share_menu_button' onClick={() => captureCard('chat')}>
                      Share in chat
                    </button>
                  </li>
                </ul>
              </nav>
            </div>

            <div className='card_wrapper' ref={cardRef}>
              <div className='panel_top'>
                <div className='logo' />
              </div>
              <div className='panel_bottom'>
                <div className='roi'>
                  <label>ROI</label>
                  <div className={`data ${pnl >= 0 ? 'won' : 'lost'}`}>{roi}</div>
                </div>
                <div className='data_grid'>
                  <div className='row'>
                    <label>Stock</label>
                    <div className='data'>
                      <div className='asset aapl'>
                        <div className='asset_icon' />
                        {!!assetData.icon2Png && <div className='asset_icon two' />}
                        {assetData.id}
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <label>Bid</label>
                    <div className='data'>
                      {side === 'buy' ? 'Up' : 'Down'} / {currencyFormatter(userFillDollarAmount)}
                    </div>
                  </div>
                  <div className='row'>
                    <label>Leverage</label>
                    <div className='data'>{leverage}x</div>
                  </div>
                  <div className='row'>
                    <label>Entry price</label>
                    <div className='data'>{entryPrice}</div>
                  </div>
                  <div className='row'>
                    <label>Exit price</label>
                    <div className='data'>{exitPrice}</div>
                  </div>
                </div>
              </div>
              <div className='url_footer'>
                <div className='powered_by'>
                  powered by <img src={logos.yolorekt_logo_inline} />
                </div>
                <div className='client_url'>
                  <a href={YOLO_BASE_URL} target='blank'>
                    {YOLO_BASE_URL.replace('https://', '').replace('http://', '')}
                  </a>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </OrderSharingCardCSS>
  )
}
